export const setupFlowSteps = [
  'Invoice check',
  'Package selection',
  'Connection',
  'Complete',
]
